// extracted by css-extract-rspack-plugin
export default {"showMore":"home-fragment__ProductSlider_showMore__MQee6","chevronLeft":"home-fragment__ProductSlider_chevronLeft__DsDG3"};